<template functional>
  <div
    v-if="props.promotions.length"
    class="promotion-banner is-hidden-tablet-only"
  >
    <img
      :src="$options.locals.sephoraLogo"
      alt="Sephora Logo"
      class="sephora-icon is-hidden-mobile"
    />
    <div class="promotion-notification">
      <ul
        :class="['promotion-list', `promotion-list-${props.promotions.length}`]"
        :style="{ '--elements-count': props.promotions.length.toString() }"
      >
        <li
          v-for="(promotion, index) in props.promotions"
          :key="index"
          class="promotion-list-item"
        >
          <a
            class="promotion-link"
            :href="promotion.url"
            :target="promotion.openInNewTab ? '_blank' : null"
            :rel="promotion.openInNewTab ? 'noopener' : null"
          >
            <span class="promotion-title">
              {{ promotion.title }}
            </span>
            <span
              v-if="promotion.subtitle"
              class="promotion-subtitle is-hidden-mobile"
            >
              {{ promotion.subtitle }}
            </span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import SephoraLogo from './assets/images/sephora-flame-icon.svg'

export default {
  locals: {
    sephoraLogo: SephoraLogo
  },
  props: {
    /**
     * Array of promotions
     *
     * @type {Array<{title: string, subtitle: string, url: string, openInNewTab: boolean}>}
     */
    promotions: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.promotion-banner {
  @include desktop {
    align-items: center;
    display: flex;
    height: 50px;
  }
}

.sephora-icon {
  height: 40px;
}

.promotion-notification {
  display: block;
  background: $black;
  height: 20px;
  width: 100%;
  overflow: hidden;

  @include desktop {
    height: 40px;
    width: 185px;
    text-transform: uppercase;
    line-height: 18px;
    display: inline-block;
    background: $white;
  }
}

// Generate keyframes for each number of supported elements.
// The 5 here indicates the maximum number of elements we want to support in the animation.
@for $elementCount from 1 to 5 {
  // Define the length of time in seconds you want the animation to go for
  $animationDuration: 0.5;
  // Define the length of time in seconds you want the animation to pause between every step
  $pauseDuration: 2;
  $totalDuration: (
      ($animationDuration + $pauseDuration) * ($elementCount - 1)
    ) +
    $pauseDuration;
  // Based on the total duration this is the percentage of the overall time that each animation step runs for
  $animationPercentage: ($animationDuration / $totalDuration) * 100;
  // Same for the pause per-step percentage
  $pausePercentage: ($pauseDuration / $totalDuration) * 100;
  // This now writes out a number of bannerScroll keyframes for each supported nr of banners.
  // eg. bannerScroll1, bannerScroll2
  @keyframes bannerScroll#{$elementCount} {
    // From start of animation to after the initial pause: no transform
    0%,
    #{$pausePercentage + '%'} {
      transform: translateY(0%);
    }
    @for $i from 1 to $elementCount {
      // For each intermediate steps X, at the end of the Xth animation: X * (pause + animation)
      // as well as at the end of the following pause:  (X * (pause + animation)) + pause
      // We are at an offset corresponding to (X * the offset of each individual banner)
      #{(($animationPercentage + $pausePercentage) * $i) + '%'},
      #{(($animationPercentage + $pausePercentage) * $i)
        + $pausePercentage
        + '%'} {
        transform: translateY(
          calc(-100% + calc(#{$i} * var(--single-element-offset)))
        );
      }
    }
    // For the last pause and at the end of the animation we are at the last element
    100%,
    #{100 - $pausePercentage + '%'} {
      transform: translateY(
        calc(-100% + calc(1 * var(--single-element-offset)))
      );
    }
  }

  .promotion-list-#{$elementCount} {
    animation-name: bannerScroll#{$elementCount};
    animation-duration: #{$totalDuration}s;
  }
}

.promotion-list {
  --single-element-offset: calc(100% / var(--elements-count));
  transition: all 300ms ease-in-out;
  animation-direction: alternate;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

.promotion-list-item {
  @include desktop {
    height: 40px;
    padding-top: 5px;
  }
}

.promotion-link {
  height: 100%;
  width: 100%;
  color: $white;
  display: flex;
  flex-direction: column;
  font-size: 12px;
  font-weight: 500;
  text-decoration: none;

  @include desktop {
    color: $black;
  }
}

.promotion-title {
  display: inline-block;
  text-align: center;

  @include desktop {
    font-size: 20px;
    letter-spacing: 2px;
    text-align: left;
  }
}

.promotion-subtitle {
  letter-spacing: 0.3px;
  font-size: 10px;
  font-weight: normal;
}
</style>
